export default __webpack_public_path__ + "static/media/processingIcon.cfd62947.svg";